import { RefObject, useEffect } from 'react';

const EDGE_TOLERANCE = 2;

export const useScrollFade = (ref: RefObject<HTMLElement | null>, dependency?: unknown) => {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const update = () => {
      const max = element.scrollWidth - element.clientWidth;
      if (max <= EDGE_TOLERANCE) {
        element.removeAttribute('data-fade');
        return;
      }
      const left = element.scrollLeft > EDGE_TOLERANCE ? 'l' : '';
      const right = element.scrollLeft < max - EDGE_TOLERANCE ? 'r' : '';
      element.setAttribute('data-fade', `${left}${right}`);
    };

    update();
    element.addEventListener('scroll', update, { passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(element);
    if (element.firstElementChild) observer.observe(element.firstElementChild);

    return () => {
      element.removeEventListener('scroll', update);
      observer.disconnect();
    };
  }, [ref, dependency]);
};
